var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
import { getInitialState as configInitState } from '../../store/configureAccount/reducer';
import storageService from '../../utils/storageService';
import { DevPlanStatusTypes, ModalType } from './models';
import { getRecentSelectedOrganizationIds } from './utils';
import { selectDevPlanSummery, selectPaymentSummery, } from '../../store/orgStatusSummery/selectors';
var selectRouter = function (state) { return state.router; };
var selectPath = function (state) { var _a, _b; return (_b = (_a = state.router) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname; };
var selectRoot = function (state) { return (state === null || state === void 0 ? void 0 : state.root) || getInitialState(); };
var selectMe = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).me; };
var selectAppOpen = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).appOpen; };
var selectGroups = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).groups; };
var selectCategories = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).categories; };
var selectTemplates = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).templates; };
var selectPermissions = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.permissions) === null || _a === void 0 ? void 0 : _a.permissions) || {}; };
var selectApps = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).apps; };
export var selectSearchString = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).searchString;
};
export var selectPlatformVersion = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).platformVersion;
};
var selectOrganizations = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).organizations;
};
var selectPayementDetails = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).paymentDetails;
};
var selectOrganizationId = function (state) {
    return (state.root || getInitialState()).selectedOrganizationId;
};
var selectOrganizationsWithWritePerm = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).appOrganizations;
};
var selectTemplate = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).template; };
var selectTemplateLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).loading;
};
var selectOverride = function (state) { return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).override; };
var selectMainSideBarState = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.root) || getInitialState()).sidebarState.main;
};
var selectIsWelcomeHold = function (state) {
    return (state.configureAccount || configInitState()).isHold;
};
var makeSelectRoot = function () { return createSelector(selectRoot, function (appState) { return appState; }); };
var makeSelectPermissions = function () {
    return createSelector(selectPermissions, function (appState) { return appState; });
};
var makeSelectRecentlySelectedOrgs = function (selectedOrganizationId) {
    return createSelector(selectOrganizations, selectMe, selectSearchString, function (organizations, me, searchString) {
        var recentlySelectedOrganizationIds = me.id
            ? getRecentSelectedOrganizationIds(me.id)
            : [];
        var recentlySelectedOrganizations = recentlySelectedOrganizationIds.map(function (id) {
            var _a;
            return ((_a = (organizations || [])) === null || _a === void 0 ? void 0 : _a.find(function (org) { return org.id === id; })) || {};
        });
        var recentlySelectedOrgsFiltered = recentlySelectedOrganizations === null || recentlySelectedOrganizations === void 0 ? void 0 : recentlySelectedOrganizations.filter(function (item) {
            var _a, _b;
            return item.id !== selectedOrganizationId &&
                ((_b = (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchString.toLowerCase()));
        });
        var orgsList = __spreadArray(__spreadArray([
            { name: "Shared Apps (".concat(me.name || me.email, ")"), id: 'shared' }
        ], (recentlySelectedOrgsFiltered || []), true), ((organizations === null || organizations === void 0 ? void 0 : organizations.filter(function (organization) {
            var _a, _b;
            return !(recentlySelectedOrganizations === null || recentlySelectedOrganizations === void 0 ? void 0 : recentlySelectedOrganizations.includes(organization)) &&
                ((_b = (_a = organization.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchString.toLowerCase()));
        })) || []), true).slice(0, 5);
        return orgsList;
    });
};
var selectModalsVisibility = function () {
    return createSelector(selectRouter, selectPaymentSummery, selectDevPlanSummery, selectIsWelcomeHold, function (router, payment, devPlanStatus, isHold) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (payment === void 0) { payment = {}; }
        if (devPlanStatus === void 0) { devPlanStatus = {}; }
        var _k = devPlanStatus.status, status = _k === void 0 ? '' : _k, _l = devPlanStatus.trialing, trialing = _l === void 0 ? {} : _l;
        var _m = payment.default_payment_method, default_payment_method = _m === void 0 ? '' : _m, _o = payment.card_payment_method, card_payment_method = _o === void 0 ? { card_valid: 3, payment_method: null } : _o;
        var card_valid = card_payment_method.card_valid;
        if ((payment === null || payment === void 0 ? void 0 : payment.default_payment_method) && devPlanStatus.status) {
            if (status === DevPlanStatusTypes.UNSET || isHold) {
                if (((default_payment_method === 'card' && card_valid === 1) ||
                    default_payment_method === 'invoice') &&
                    !isHold) {
                    if (!((_a = router === null || router === void 0 ? void 0 : router.location) === null || _a === void 0 ? void 0 : _a.pathname.includes('/partner/organizations')) &&
                        (((_b = router === null || router === void 0 ? void 0 : router.location) === null || _b === void 0 ? void 0 : _b.pathname.includes("/payments")) ||
                            ((_c = router === null || router === void 0 ? void 0 : router.location) === null || _c === void 0 ? void 0 : _c.pathname.includes('/apps')))) {
                        return ModalType.SELECT;
                    }
                }
                // DevPlan = 'unset' && !payment
                else {
                    return ModalType.WELCOME;
                }
            }
            if (!((_d = router === null || router === void 0 ? void 0 : router.location) === null || _d === void 0 ? void 0 : _d.pathname.includes('/partner/organizations')) &&
                (((_e = router === null || router === void 0 ? void 0 : router.location) === null || _e === void 0 ? void 0 : _e.pathname.includes("/payments")) ||
                    ((_f = router === null || router === void 0 ? void 0 : router.location) === null || _f === void 0 ? void 0 : _f.pathname.includes("/developerPlans")) ||
                    ((_g = router === null || router === void 0 ? void 0 : router.location) === null || _g === void 0 ? void 0 : _g.pathname.includes('/apps')))) {
                if (status === DevPlanStatusTypes.CANCELED ||
                    status === DevPlanStatusTypes.INCOMPLETE ||
                    status === DevPlanStatusTypes.INCOMPLETE_EXPIRED ||
                    status === DevPlanStatusTypes.UNPAID) {
                    // !DevPlan && payment
                    if (((default_payment_method === 'card' && card_valid === 1) ||
                        default_payment_method === 'invoice') &&
                        !((_h = router === null || router === void 0 ? void 0 : router.location) === null || _h === void 0 ? void 0 : _h.pathname.includes("/developerPlans")))
                        return ModalType.SELECT;
                    // !DevPlan && !payment
                    else {
                        return ModalType.CONFIGURE;
                    }
                }
                else if (status === DevPlanStatusTypes.ACTIVE ||
                    (status === DevPlanStatusTypes.TRIALING &&
                        !(trialing === null || trialing === void 0 ? void 0 : trialing.trial_payment_optional)) ||
                    status === DevPlanStatusTypes.PAST_DUE) {
                    // DevPlan && !payment
                    if (default_payment_method === 'card' &&
                        card_valid !== 1 &&
                        !((_j = router === null || router === void 0 ? void 0 : router.location) === null || _j === void 0 ? void 0 : _j.pathname.includes("/payments"))) {
                        return ModalType.PAYMENT;
                    }
                }
                else if (status === DevPlanStatusTypes.ERROR) {
                    return ModalType.CONTACT;
                }
            }
        }
    });
};
export var selectModalsOverride = function () {
    return createSelector(selectOverride, function (override) { return override; });
};
export var selectConsumptionModalsVisibility = function () {
    return createSelector(selectOverride, function (override) { return override; });
};
export var selectPaymentStatus = createSelector(selectRoot, selectDevPlanSummery, selectPaymentSummery, function (appstore, devPlanStatus, paymentDetails) {
    var _a;
    return !!(paymentDetails.default_payment_method === 'card' &&
        ((_a = paymentDetails.card_payment_method) === null || _a === void 0 ? void 0 : _a.card_valid) !== 1 &&
        (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) &&
        (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) !== DevPlanStatusTypes.TRIALING);
});
export var makeSelectMedia = function () {
    return createSelector(selectRoot, function (_a) {
        var files = _a.files, filesMeta = _a.filesMeta;
        return ({
            files: files,
            filesMeta: filesMeta,
        });
    });
};
var makeSelectUser = function () {
    return createSelector(selectRoot, function (appState) {
        var result = __assign(__assign({}, appState), { me: appState.me ? __assign({}, appState.me) : appState.me });
        result.token = storageService.getItem('token');
        return result;
    });
};
var makeSelectResetPassword = function () {
    return createSelector(selectRoot, function (appState) { return ({
        resetPassword_request: appState.resetPassword_request,
        resetPassword_error: appState.resetPassword_error,
    }); });
};
var makeSelectNewPassword = function () {
    return createSelector(selectRoot, function (appState) { return ({
        savePassword_request: appState.savePassword_request,
        savePassword_error: appState.savePassword_error,
    }); });
};
var makeSelectApps = function () {
    return createSelector(selectRoot, function (appState) { return appState.apps || []; });
};
var makeSelectAllOrgApps = function () {
    return createSelector(selectRoot, function (appState) { return appState.allOrgApps || []; });
};
var makeSelectOrgApps = function () {
    return createSelector(selectRoot, function (appState) { return appState.orgApps || []; });
};
var makeSelectConnectedApps = function () {
    return createSelector(selectRoot, function (appState) { return appState.appsDetails || []; });
};
var makeSelectConnectedPatches = function () {
    return createSelector(selectRoot, function (appState) { return appState.patchesDetails || []; });
};
var makeSelectConnectedViews = function () {
    return createSelector(selectRoot, function (appState) { return appState.viewsDetails || []; });
};
var makeSelectConnectLoading = function () {
    return createSelector(selectRoot, function (appState) { return appState.checkLoading || false; });
};
var makeSelectAllOrgAppsLoading = function () {
    return createSelector(selectRoot, function (appState) { return appState.loadingAllOrgApps || false; });
};
var makeSelectAppTemplates = function () {
    return createSelector(selectRoot, function (appState) { return appState.templates || []; });
};
export var makeSelectAppTemplateIndex = function () {
    return createSelector(selectRoot, function (appState) {
        return (appState.templates || []).reduce(function (acc, template) {
            acc[template.app] = template;
            return acc;
        }, {});
    });
};
var makeSelectAppCreateError = function () {
    return createSelector(selectRoot, function (appState) { return appState.createApp_error; });
};
var makeSelectAppsMeta = function () {
    return createSelector(selectRoot, function (appState) { return appState.apps_meta; });
};
var makeSelectLoading = function () {
    return createSelector(selectRoot, function (appState) { return appState.loading; });
};
var makeSelectLoadingApps = function () {
    return createSelector(selectRoot, function (appState) { return appState.loadingApps; });
};
var makeSelectPaginationIndex = function (paginationName) { return function () {
    return createSelector(selectRoot, function (appState) { return appState.paginationIndexes[paginationName] || 0; });
}; };
var getSecondarySideBarState = function (state) { return state.root.secondaryMenuState; };
var getMainSideBarState = function (state) { return state.root.mainMenuState; };
export var selectOpenApp = createSelector(selectAppOpen, selectApps, function (_a, apps) {
    var _b;
    var lastUrl = _a.lastUrl, appId = _a.appId;
    var app = (_b = (apps || [])) === null || _b === void 0 ? void 0 : _b.find(function (app) { return app.id === appId; });
    if (!app) {
        return null;
    }
    return __assign(__assign({}, app), { lastUrl: lastUrl });
});
var makeSelectInitialized = function () {
    return createSelector(selectRoot, function (appState) { return appState.initialized; });
};
var makeSelectOrgInitialized = function () {
    return createSelector(selectRoot, function (appState) { return appState.organizationsInitialized; });
};
var makeSelectUserContext = function () {
    return createSelector(selectRoot, makeSelectUser(), function (appState, user) { return ({
        organizations: __spreadArray([{}], appState.organizations, true),
        groups: appState.groups,
        selectedOrganizationId: appState.selectedOrganizationId,
        termsAccepted: appState.termsAccepted,
        user: user,
    }); });
};
var makeSelectOrg = function () {
    return createSelector(selectRoot, function (appState) {
        return {
            selectedOrganizationId: appState.selectedOrganizationId,
        };
    });
};
export var selectOrg = createSelector(selectRoot, function (appState) {
    var _a = appState.organizations, organizations = _a === void 0 ? [] : _a, selectedOrganizationId = appState.selectedOrganizationId;
    return (organizations === null || organizations === void 0 ? void 0 : organizations.find(function (o) { return o.id === selectedOrganizationId; })) || null;
});
var makeSelectRole = function () {
    return createSelector(selectRoot, function (appState) {
        var _a, _b;
        var selectedOrganizationId = appState.selectedOrganizationId, _c = appState.groups, groups = _c === void 0 ? [] : _c, _d = appState.organizations, organizations = _d === void 0 ? [] : _d;
        var group = groups === null || groups === void 0 ? void 0 : groups.find(function (item) { return item.organization === selectedOrganizationId; });
        var roleSelectorObject = {
            selectedOrganizationId: 'Loading...',
            currentRole: group ? getRoleString(group) : 'N/A',
        };
        var organizationName = selectedOrganizationId === 'shared'
            ? 'Shared Apps'
            : (_b = (_a = (organizations || [])) === null || _a === void 0 ? void 0 : _a.find(function (organization) { return organization.id === selectedOrganizationId; })) === null || _b === void 0 ? void 0 : _b.name;
        return organizationName
            ? __assign(__assign({}, roleSelectorObject), { selectedOrganizationId: organizationName }) : roleSelectorObject;
    });
};
var makeSelectBarState = function () {
    return createSelector(selectRoot, function (appState) { return ({
        secondarySideBar: getSecondarySideBarState({ root: appState }),
        mainSideBar: getMainSideBarState({ root: appState }),
    }); });
};
var makeSelectPlatformVersion = function () {
    return createSelector(selectRoot, function (appState) { return appState.platformVersion || []; });
};
var makeSelectOrganization = function () {
    return createSelector(selectOrganizations, selectOrganizationId, makeSelectOrg, function (organizations, selectedOrganizationId) {
        return ((organizations === null || organizations === void 0 ? void 0 : organizations.find(function (org) { return org.id === selectedOrganizationId; })) || {});
    });
};
var makeSelectOrganizations = function () {
    return createSelector(selectOrganizations, function (organizations) {
        return (organizations === null || organizations === void 0 ? void 0 : organizations.length) ? organizations : [];
    });
};
var makeSelectOrganizationsWithWritePerm = function () {
    return createSelector(selectOrganizationsWithWritePerm, function (organizations) { return organizations; });
};
var makeSelectTemplate = function () {
    return createSelector(selectTemplate, function (template) { return template; });
};
var makeSelectTemplateLoading = function () {
    return createSelector(selectTemplateLoading, function (loading) { return loading; });
};
var makeSelectCategories = function () {
    return createSelector(selectCategories, function (categories) { return categories; });
};
var makeSelectMainSidebarState = function () {
    return createSelector(selectMainSideBarState, selectRouter, function (isOpen, router) {
        var _a, _b, _c, _d, _e;
        var excludes = !((_a = router === null || router === void 0 ? void 0 : router.location) === null || _a === void 0 ? void 0 : _a.pathname.includes("apps/new")) &&
            !((_b = router === null || router === void 0 ? void 0 : router.location) === null || _b === void 0 ? void 0 : _b.pathname.includes("organizations/new"));
        if ((((_c = router === null || router === void 0 ? void 0 : router.location) === null || _c === void 0 ? void 0 : _c.pathname.includes("apps/")) ||
            ((_d = router === null || router === void 0 ? void 0 : router.location) === null || _d === void 0 ? void 0 : _d.pathname.includes("organizations/")) ||
            ((_e = router === null || router === void 0 ? void 0 : router.location) === null || _e === void 0 ? void 0 : _e.pathname.includes("partner/"))) &&
            excludes)
            return { isVisible: true, isOpen: isOpen };
        return { isVisible: false, isOpen: isOpen };
    });
};
var getRoleString = function (orgObj) {
    for (var role in ROLE_LIST) {
        if (orgObj.name === role) {
            return ROLE_LIST[role];
        }
    }
    return 'N/A';
};
var ROLE_LIST = {
    admins: 'Super Admin',
    members: 'Member',
    appowner: 'App Owner',
    appadmin: 'App Admin',
    partner: 'Partner',
    developer: 'Developer',
    appmanager: 'App Manager',
    designer: 'Designer',
    contentagent: 'Content Agent',
};
export { selectMe, selectRoot, selectAppOpen, selectRouter, selectGroups, selectApps, selectTemplates, selectOrganizations, selectOrganizationsWithWritePerm, selectCategories, selectPermissions, selectOrganizationId, selectPayementDetails, makeSelectRoot, makeSelectUser, makeSelectAllOrgApps, makeSelectAllOrgAppsLoading, makeSelectApps, makeSelectAppsMeta, makeSelectAppTemplates, makeSelectPermissions, makeSelectRecentlySelectedOrgs, makeSelectResetPassword, makeSelectLoading, makeSelectLoadingApps, makeSelectPaginationIndex, getSecondarySideBarState, getMainSideBarState, makeSelectInitialized, makeSelectOrgInitialized, makeSelectUserContext, makeSelectNewPassword, makeSelectAppCreateError, makeSelectOrg, makeSelectRole, makeSelectBarState, makeSelectPlatformVersion, makeSelectOrganizations, makeSelectOrganizationsWithWritePerm, makeSelectCategories, makeSelectTemplate, selectTemplateLoading, makeSelectTemplateLoading, makeSelectOrganization, selectPath, selectModalsVisibility, makeSelectMainSidebarState, selectOverride, selectMainSideBarState, makeSelectConnectedApps, makeSelectConnectedPatches, makeSelectConnectLoading, makeSelectConnectedViews, makeSelectOrgApps, };
